import {
	GET_COMPANY_FAIL,
	GET_COMPANY_START,
	GET_COMPANY_SUCCESS,
	GET_USERS_COMPANY_FAIL,
	GET_USERS_COMPANY_START,
	GET_USERS_COMPANY_SUCCESS, REGISTER_COMPANY_USER_FAIL,
	REGISTER_COMPANY_USER_START, REGISTER_COMPANY_USER_SUCCESS,
	UPDATE_COMPANY_FAIL,
	UPDATE_COMPANY_START,
	UPDATE_COMPANY_SUCCESS,
	ADD_EMAIL_START,
	ADD_EMAIL_FAIL,
	ADD_EMAIL_SUCCESS
} from "../reducers/actions/ActionTypes";
import axios from "axios";
import {getConfig} from "./utils/ConfigUtils";
import {getErrorMessage} from "../reducers/utils/ReducerUtils";
import {
	SEND_RESET_EMAIL_URL,
	GET_COMPANY_URL,
	GET_USERS_COMPANY_URL,
	UPDATE_COMPANY_URL,
	AUTH_REGIST_COMPANY_USER_URL
} from "./utils/ApiUrls";
import {authLogout} from "./AuthServices";

export function updateCompany(data, dispatch) {
	dispatch({type: UPDATE_COMPANY_START});
	axios
		.post(UPDATE_COMPANY_URL, data, getConfig())
		.then(() => dispatch({type: UPDATE_COMPANY_SUCCESS}))
		.catch((error) => dispatch({type: UPDATE_COMPANY_FAIL, error: getErrorMessage(error)}))
}

export function getCompany(idCompany, dispatch) {
	dispatch({type: GET_COMPANY_START});
	axios
		.get(GET_COMPANY_URL + idCompany, getConfig())
		.then((response) => dispatch({type: GET_COMPANY_SUCCESS, payload: response.data}))
		.catch((error) => dispatch({type: GET_COMPANY_FAIL, error: getErrorMessage(error)}))
}

export function getUsersByCompany(idCompany, dispatch) {
	dispatch({type: GET_USERS_COMPANY_START});
	axios
		.get(GET_USERS_COMPANY_URL + idCompany, getConfig())
		.then((response) => {
			if (response.status === 226){
				authLogout();
			} else {
				dispatch({type: GET_USERS_COMPANY_SUCCESS, payload: response.data})
			}
		})
		.catch((error) => dispatch({type: GET_USERS_COMPANY_FAIL, error: getErrorMessage(error)}))
}

export function sendResetEmail(username, dispatch) {
	dispatch({type: ADD_EMAIL_START});
	axios
		.get(SEND_RESET_EMAIL_URL + username, getConfig())
		.then((response) => dispatch({type: ADD_EMAIL_SUCCESS, payload: response.data}))
		.catch((error) => dispatch({type: ADD_EMAIL_FAIL, error: getErrorMessage(error)}))
}

export function registerCompanyUser(user, dispatch) {
	dispatch({type: REGISTER_COMPANY_USER_START});
	axios
		.post(AUTH_REGIST_COMPANY_USER_URL, user, getConfig())
		.then(() => dispatch({type: REGISTER_COMPANY_USER_SUCCESS}))
		.catch((error) => dispatch({type: REGISTER_COMPANY_USER_FAIL, error: getErrorMessage(error)}))
}
